import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Snackbar, Alert } from "@mui/material";
import { postData, API_ENDPOINTS } from "../../services/apiService";
import "./User-Sign-In.css";

function LogIn() {
  const [mobileNumber, setMobileNumber] = useState("");
  const [otp, setOtp] = useState("");
  const [mobileNumberError, setMobileNumberError] = useState("");
  const [otpError, setOtpError] = useState("");
  const [mobileNumberTouched, setMobileNumberTouched] = useState(false);
  const [otpTouched, setOtpTouched] = useState(false);
  const [loading, setLoading] = useState(false);
  const [apiError, setApiError] = useState("");

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  const navigate = useNavigate();

  const validateMobileNumber = (number) => {
    const regex = /^\d{10}$/;
    if (!number) return "Mobile number is required.";
    if (!regex.test(number)) return "Enter a valid 10-digit number.";
    return "";
  };

  const validateOtp = (code) => {
    const regex = /^\d{4,6}$/;
    if (!code) return "OTP is required.";
    if (!regex.test(code)) return "Enter a valid OTP (4–6 digits).";
    return "";
  };

  const handleMobileNumberChange = (e) => {
    const numericValue = e.target.value.replace(/\D/g, "");
    setMobileNumber(numericValue);
    if (mobileNumberTouched) {
      setMobileNumberError(validateMobileNumber(numericValue));
    }
  };

  const handleOtpChange = (e) => {
    const numericValue = e.target.value.replace(/\D/g, "");
    setOtp(numericValue);
    if (otpTouched) {
      setOtpError(validateOtp(numericValue));
    }
  };

  const handleGetOtp = async () => {
    if (!mobileNumber) {
      setSnackbarMessage("Please enter a mobile number");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
      return;
    }
    try {
      const payload = { mobile_num: Number(mobileNumber) };
      const response = await postData(API_ENDPOINTS.sendOtp, payload);

      if (response.statusCode === 200) {
        setSnackbarMessage(`${response.message} (OTP: ${response.result.otp})`);
        setSnackbarSeverity("success");
      } else {
        setSnackbarMessage(response.message || "Failed to send OTP");
        setSnackbarSeverity("error");
      }
      setSnackbarOpen(true);
    } catch {
      setSnackbarMessage("Error while sending OTP");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMobileNumberTouched(true);
    setOtpTouched(true);

    const mobileNumberValidation = validateMobileNumber(mobileNumber);
    const otpValidation = validateOtp(otp);

    setMobileNumberError(mobileNumberValidation);
    setOtpError(otpValidation);

    if (mobileNumberValidation || otpValidation) return;

    setLoading(true);
    setApiError("");

    try {
      const payload = { mobile_num: Number(mobileNumber), otp };
      const data = await postData(API_ENDPOINTS.verifyOtpLogin, payload);

      if (data.statusCode === 200) {
        localStorage.setItem("userData", JSON.stringify(data.result));
        localStorage.setItem("authToken", data.result.token);

        setSnackbarMessage(data.message || "Login successful");
        setSnackbarSeverity("success");
        setSnackbarOpen(true);

        setTimeout(() => navigate("/app/dashboard"), 500);
      } else {
        setSnackbarMessage(data.message || "Login failed");
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
      }
    } catch {
      setSnackbarMessage("Error during login");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-left-panel">
        <img src="/smart-vectors/Truck-App-Logo.svg" alt="" className="logo-svg" />
        <h2>Explore the world of shipping</h2>
        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <input
              type="tel"
              placeholder="Mobile Number"
              value={mobileNumber}
              onChange={handleMobileNumberChange}
              onBlur={() => {
                setMobileNumberTouched(true);
                setMobileNumberError(validateMobileNumber(mobileNumber));
              }}
              className={mobileNumberError && mobileNumberTouched ? "input-error" : ""}
            />
            {mobileNumberError && mobileNumberTouched && (
              <p className="error-message">{mobileNumberError}</p>
            )}
          </div>

          <p className="otp-label" onClick={handleGetOtp}>
            Get Otp
          </p>

          <div className="form-group">
            <input
              type="tel"
              placeholder="Enter Otp"
              value={otp}
              onChange={handleOtpChange}
              onBlur={() => {
                setOtpTouched(true);
                setOtpError(validateOtp(otp));
              }}
              className={otpError && otpTouched ? "input-error" : ""}
            />
            {otpError && otpTouched && <p className="error-message">{otpError}</p>}
          </div>

          {apiError && <p className="error-message">{apiError}</p>}

          <button type="submit" disabled={loading}>
            {loading ? "Logging in..." : "Log In"}
          </button>
        </form>
      </div>

      <div className="login-right-panel">
        <img src="/images/Login-Screen-Wallpaper.png" alt="Login Illustration" />
      </div>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={() => setSnackbarOpen(false)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={() => setSnackbarOpen(false)} severity={snackbarSeverity}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </div>
  );
}

export default LogIn;
